import * as React from 'react';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;
const NARROW_PHONE_BREAKPOINT = 376; // ≤ 375 px

const getServerSnapshot = () => false;

/** Keep the first hydration render identical to SSR, then use the real viewport. */
export function useMediaQuery(query: string): boolean {
  const subscribe = React.useCallback((onChange: () => void) => {
    const mql = window.matchMedia(query);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  const getSnapshot = React.useCallback(() => window.matchMedia(query).matches, [query]);
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function useIsMobile() {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

export function useBreakpoint(): Breakpoint {
  const isMobile = useIsMobile();
  const belowDesktop = useMediaQuery(`(max-width: ${TABLET_BREAKPOINT - 1}px)`);
  return isMobile ? 'mobile' : belowDesktop ? 'tablet' : 'desktop';
}

/** Returns true for phones ≤ 375 px wide (narrow phones). */
export function useIsNarrowPhone(): boolean {
  return useMediaQuery(`(max-width: ${NARROW_PHONE_BREAKPOINT - 1}px)`);
}
